<template>
  <div class="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[9999]">
    <div class="relative bg-white shadow-lg w-full md:w-[500px] h-[640px] rounded-lg">
      <button
       @click="$emit('closeModal')"
        class="absolute top-0 right-0  p-2 bg-gray-200 rounded-lg hover:bg-gray-300 focus:outline-none"
      >
        <svg
          class="w-6 h-6 text-gray-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </button>
      <!-- Iframe -->
      <iframe
        src="https://widget.vignan.prod.umsglobal.net/#/?color=white&leadOwner=vignan_landing_page&leadSource=Organic&leadOrigin=Website&academia_id=7A1FA08E-A78C-453E-8D0B-F394598A5922&university=vignan&widget_id=afbbc6f1-2bb9-4834-a960-fed053e99002"
        width="100%"
        height="100%"
        frameborder="0"
        class="rounded-lg"
      ></iframe>
    
    </div>
  </div>
</template>
<script>
// import axios from 'axios';
export default {
  name: "EnquireNow",
  props:["closeModal"]
};
</script>
